import { TranslationMap } from '@trimble-gcs/i18n-types';

export function noAccessTranslations() {
  return {
    noAccess: {
      title: {
        text: $localize`:@@auth.noAccess.title:Insufficient Permissions`,
        desc: 'Title for the message that the user does not have sufficient role access.',
      },
      message: {
        text: $localize`:@@auth.noAccess.message:You don't have the required permission.`,
        desc: 'Message to user that they do not have sufficient role access.',
      },
    },
  } satisfies TranslationMap;
}
